<app-company-message
  *ngIf="thread"
  class="alert alert-warning"
  [author]="thread.messages.last.sender.name"
  [subject]="thread.subject"
  [text]="thread.messages.last.content"
  (close)="readMessage()"
></app-company-message>